import React from 'react';
import { Link } from 'react-router-dom';

const Policy = () => {
  return (
    <div>
      <div className='tuto1'>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <div className='tuto-ttl'>
                <h1>Contact Card</h1>
                <span>The Business Card Innovation</span>
                <Link to='/'>
                  <div className='col-12 text-right p-0'>
                    <img
                      src='https://firebasestorage.googleapis.com/v0/b/digitalcontacts-2699b.appspot.com/o/images%2Fxclose.png?alt=media&token=2f2ef0c7-8090-47f6-974a-2a93cc4f05d6'
                      width='25'
                      alt='QR CODE'
                    />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='my-profile'>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <h1>Privacy Policy</h1>
              <p>
                Privacy Policy Last modified: March 22, 2022 Introduction
                Digital Contact Card. ("Company" or&nbsp;"We") respect your
                privacy and are committed to protecting it through our
                compliance with this policy. This policy describes the types of
                information we may collect from you or that you may provide when
                you visit the Digital Contact Card website (our "Website")
                and/or use any Digital Contact Card software applications (our
                “Apps”), collectively referred to as the “Service”, and our
                practices for collecting, using, maintaining, protecting, and
                disclosing that information, and is incorporated by reference
                into the Digital Contact Card Terms of Use. This policy applies
                to information we collect: 〈 On the Website. 〈 Within the
                Apps. 〈 In email, text, and other electronic messages between
                you and this Service. It does not apply to information collected
                by: 〈 us offline or through any other means, including on any
                other website operated by Company or any third party (including
                our affiliates and subsidiaries); or 〈 any third party
                (including our affiliates and subsidiaries), including through
                any application or content (including advertising) that may link
                to or be accessible from or on the Service. Please read this
                policy carefully to understand our policies and practices
                regarding your information and how we will treat it. If you do
                not agree with our policies and practices, your choice is not to
                use our Service. By accessing or using this Service, you agree
                to this privacy policy. This policy may change from time to
                time. Your continued use of this Service after we make changes
                is deemed to be acceptance of those changes, so please check the
                policy periodically for updates. Children Under the Age of 13
                Our Service is not intended for children under 13 years of age.
                No one under age 13 may provide any information to or on the
                Service. We do not knowingly collect personal information from
                children under 13. If you are under 13, do not use or provide
                any information on this Service or on or through any of its
                features. If we learn we have collected or received personal
                information from a child under 13 without verification of
                parental consent, we will delete that information. If you
                believe we might have any information from or about a child
                under 13, please contact us at sales@digitalcontactcard.com
                Information We Collect About You and How We Collect It We
                collect several types of information from and about users of our
                Service, including information: • by which you may be personally
                identified, such as name, mailing address, e-mail address,
                telephone number, or social media screen names, any other
                identifier by which you may be contacted online or offline]
                ("personal information"); • that is about you but individually
                does not identify you; and/or • about your internet connection,
                the equipment you use to access our Service and usage details.
                We collect this information: • Directly from you when you
                provide it to us. • Automatically as you navigate through the
                Service. Information collected automatically may include usage
                details, IP addresses, and information collected through
                cookies, web beacons, GPS location, and other tracking
                technologies. • From third parties, for example, other social
                media providers and/or our business partners. Information You
                Provide to Us. The information we collect on or through our
                Service may include: • Information that you provide by filling
                in forms on our Service. This includes information provided at
                the time of registering to use our Service and/or posting
                material. We may also ask you for information when you report a
                problem with our Service. • Records and copies of your
                correspondence (including email addresses), if you contact us. •
                Your search queries within the Service. • Your information
                provided by other social networks you use. We collect
                information from your Social Networks when you log in with
                social networking credentials. For example, when you log in with
                your Facebook credentials, we collect the personal information
                you have made publicly available in Facebook, such as name,
                email address, profile picture, location, gender, age, friends,
                and the like. You also may provide information to be published
                or displayed (hereinafter, "posted") on public areas of the
                Service, or transmitted to other users of the Service or third
                parties (collectively, "User Contributions"). Your User
                Contributions are posted on and transmitted to others at your
                own risk. Although you may set certain privacy settings for such
                information by logging into your account profile, please be
                aware that no security measures are perfect or impenetrable.
                Additionally, we cannot control the actions of other users of
                the Service with whom you may choose to share your User
                Contributions. Therefore, we cannot and do not guarantee that
                your User Contributions will not be viewed by unauthorized
                persons. Information We Collect Through Automatic Data
                Collection Technologies. As you navigate through and interact
                with our Service, we may use automatic data collection
                technologies to collect certain information about your
                equipment, browsing actions, and patterns, including: • Details
                of your visits to our Service, including traffic data, location
                data, logs, and other communication data and the resources that
                you access and use on the Service. • Information about your
                computer and internet connection, including your IP address,
                operating system, and browser type. • Location information from
                your mobile device. We will collect and may store your location
                information if you enable your mobile device to send it to use.
                Collection of this information will help to improve the Apps,
                and will allow location-based functionality such as “checking
                in” at locations and/or being made aware of other users, or
                other information, within your vicinity. • We also may use these
                technologies to collect information about your online activities
                over time and across third-party websites or other online
                services (behavioral tracking). The information we collect
                automatically may include personal information, or we may
                maintain it or associate it with personal information we collect
                in other ways or receive from third parties. It helps us to
                improve our Service and to deliver a better and more
                personalized Service, including by enabling us to: • Estimate
                our audience size and usage patterns. • Store information about
                your preferences, allowing us to customize our Service according
                to your individual interests. • Speed up your searches. •
                Recognize you when you return to our Service. The technologies
                we use for this automatic data collection may include: • Cookies
                (or browser cookies). A cookie is a small file placed in users’
                browsers to store their preference. You may refuse to accept
                browser cookies by activating the appropriate setting on your
                browser. However, if you select this setting you may be unable
                to access certain parts of our Website or Service. Unless you
                have adjusted your browser setting so that it will refuse
                cookies, our system will issue cookies when you direct your
                browser to our Website. By using an App, you authorize us to
                gather and retain data related to your use of the Service. •
                Flash Cookies. Certain features of our Website may use local
                stored objects (or Flash cookies) to collect and store
                information about your preferences and navigation to, from, and
                on our Website. Flash cookies are not managed by the same
                browser settings as are used for browser cookies. • Web Beacons.
                Pages of our Website, our Apps, and our e-mails may contain
                small electronic files known as web beacons (also referred to as
                clear gifs, pixel tags, and single-pixel gifs) that permit the
                Company, for example, to count users who have visited those
                pages or opened an email and for other related website
                statistics (for example, recording the popularity of certain
                website content and verifying system and server integrity).
                Third-Party Use of Cookies [and Other Tracking Technologies Some
                content or applications, including advertisements, on the
                Service are served by third-parties, including advertisers, ad
                networks and servers, content providers, and application
                providers. These third parties may use cookies alone or in
                conjunction with web beacons or other tracking technologies to
                collect information about you when you use our Service. The
                information they collect may be associated with your personal
                information or they may collect information, including personal
                information, about your online activities over time and across
                different websites and other online services. They may use this
                information to provide you with interest-based (behavioral)
                advertising or other targeted content. We do not control these
                third parties' tracking technologies or how they may be used. If
                you have any questions about an advertisement or other targeted
                content, you should contact the responsible provider directly.
                How We Use Your Information We use information that we collect
                about you or that you provide to us, including any personal
                information: • To present our Service and its contents to you. •
                To provide you with information, products, or services that you
                request from us. • To fulfill any other purpose for which you
                provide it. • To provide you with notices about your account,
                including expiration and renewal notices. • To carry out our
                obligations and enforce our rights arising from any contracts
                entered into between you and us, including for billing and
                collection. • To notify you about changes to our Service or any
                products or services we offer or provide though it. • To allow
                you to participate in interactive features on our Service. • In
                any other way we may describe when you provide the information.
                • For any other purpose with your consent. • We will only ever
                share your personal information with third parties after having
                obtained your express consent to do so. You may ask us to stop
                using your personal information for this purpose at any point by
                changing the setting authorizing the third party disclosure. We
                may also use your information to contact you about our own and
                third-parties' goods and services that may be of interest to
                you. If you do not want us to use your information in this way,
                please adjust your user preferences in your account profile. We
                may use the information we have collected from you to enable us
                to display advertisements to our advertisers' target audiences.
                Even though we do not disclose your personal information for
                these purposes without your consent, if you click on or
                otherwise interact with an advertisement, the advertiser may
                assume that you meet its target criteria. Disclosure of Your
                Information We may disclose aggregated information about our
                users, and information that does not identify any individual,
                without restriction. We may disclose personal information that
                we collect or you provide as described in this privacy policy: •
                To our subsidiaries and affiliates. • To contractors, service
                providers, and other third parties we use to support our
                business. • To a buyer or other successor in the event of a
                merger, divestiture, restructuring, reorganization, dissolution,
                or other sale or transfer of some or all of us assets, whether
                as a going concern or as part of bankruptcy, liquidation, or
                similar proceeding, in which personal information held by us
                about our Service users is among the assets transferred. • To
                third parties to market their products or services to you if you
                have not opted out of these disclosures. • To fulfill the
                purpose for which you provide it. For example, if you give us an
                email address to use the "email a friend" feature of our
                Service, we will transmit the contents of that email and your
                email address to the recipients, or if you enable interaction
                with other social media networks with our Service, we will
                transmit the information you provide to those other social
                networks. • For any other purpose disclosed by us when you
                provide the information. • With your consent. We may also
                disclose your personal information: • To comply with any court
                order, law, or legal process, including to respond to any
                government or regulatory request. • To enforce or apply our
                terms of use and other agreements, including for billing and
                collection purposes. • If we believe disclosure is necessary or
                appropriate to protect the rights, property, or our safety .,
                our customers, or others. Choices About How We Use and Disclose
                Your Information We strive to provide you with choices regarding
                the personal information you provide to us. We have created
                mechanisms to provide you with the following control over your
                information: • Tracking Technologies and Advertising. You can
                set your browser to refuse all or some browser cookies, or to
                alert you when cookies are being sent. To learn how you can
                manage your Flash cookie settings, visit the Flash player
                settings page on Adobe's website. If you disable or refuse
                cookies, please note that some parts of this Service may then be
                inaccessible or not function properly. We do not control third
                parties' collection or use of your information to serve
                interest-based advertising. However these third parties may
                provide you with ways to choose not to have your information
                collected or used in this way. You can opt out of receiving
                targeted ads from members of the Network Advertising Initiative
                ("NAI") on the NAI's website. Accessing and Correcting Your
                Information You can review and change your personal information
                by logging into the Service and visiting your account profile
                page. If you delete your User Contributions from the Website,
                copies of your User Contributions may remain viewable in cached
                and archived pages, or might have been copied or stored by other
                Service users. Proper access and use of information provided on
                the Service, including User Contributions, is governed by our
                terms of use. Your California Privacy Rights California Civil
                Code Section § 1798.83 permits users of our Service that are
                California residents to request certain information regarding
                our disclosure of personal information to third parties for
                their direct marketing purposes. To make such a request, please
                send an email to sales@digitalcontactcard.com. Data Security We
                have implemented measures designed to secure your personal
                information from accidental loss and from unauthorized access,
                use, alteration, and disclosure. The safety and security of your
                information also depends on you. Where we have given you (or
                where you have chosen) a password for access to certain parts of
                our Service, you are responsible for keeping this password
                confidential. We ask you not to share your password with anyone.
                We urge you to be careful about giving out information in public
                areas of the Service. The information you share in public areas
                may be viewed by any user of the Service. Unfortunately, the
                transmission of information via the internet is not completely
                secure. Although we do our best to protect your personal
                information, we cannot guarantee the security of your personal
                information transmitted to our Service. Any transmission of
                personal information is at your own risk. We are not responsible
                for circumvention of any privacy settings or security measures
                contained in the Service. Changes to Our Privacy Policy It is
                our policy to post any changes we make to our privacy policy on
                this page with a notice that the privacy policy has been
                updated. If we make material changes to how we treat our users'
                personal information, we will notify you by email to the email
                address specified in your account and/or through a notice
                provided within the Service. The date the privacy policy was
                last revised is identified at the top of the page. You are
                responsible for ensuring we have an up-to-date active and
                deliverable email address for you, and for periodically visiting
                our Service and this privacy policy to check for any changes.
                Contact Information To ask questions or comment about this
                privacy policy and our privacy practices, contact us at:
                b2b@digitalcontactcard.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policy;
